import TextBlock from "./TextBlock";

const BulletListBlock = ({ block }) => {
  const content = block.content;
  return (
    <ul className="bullet-list-block">
      {content.map((item, index) => (
        <li key={`bullet-item-${index}`} className="bullet-list-item">
          <TextBlock block={item} />
        </li>
      ))}
    </ul>
  );
};

export default BulletListBlock;